import { useEffect, useRef } from 'react';
import { pushEscapeHandler } from '@/lib/escapeStack';

/**
 * 「開いている間だけ」Escape キーで onClose を呼ぶ共通フック。
 *
 * 絞り込みドロップダウン・三点メニュー・通知ベル・モーダルなど、
 * 開閉する要素すべてで同じ操作感にするための部品。
 * 内部では共通スタックに登録し、複数が重なって開いても
 * Escape 1回で「いちばん最後に開いたもの」だけを閉じる。
 *
 * @param open    開いているか
 * @param onClose 閉じるときの処理
 */
export function useEscapeKey(open: boolean, onClose: () => void): void {
  // onClose の同一性が毎レンダー変わっても、登録・解除を繰り返さないように ref で持つ。
  const handlerRef = useRef(onClose);
  handlerRef.current = onClose;

  useEffect(() => {
    if (!open) return;
    return pushEscapeHandler(() => handlerRef.current());
  }, [open]);
}

export default useEscapeKey;